// extracted by mini-css-extract-plugin
export var phone = "_22-0";
export var phoneDragging = "_22-1";